class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.checkUrlForOpenCart();

    // Listen for event when product is added to cart by Instagram Section (Stamped)
    // stamped:widget:instagram-feed:added-to-cart
    document.addEventListener("stamped:widget:instagram-feed:added-to-cart", (e) => {
      const currentHref = window.location.href.split("?")[0];
      const currentParams = window.location.href.split("?")[1];
      const redirectUrl = `${currentHref}${currentParams ? `?${currentParams}&` : "?"}${
        !currentParams || !currentParams.includes("openCart") ? "openCart=true" : ""
      }`;

      window.location.href = redirectUrl;
    });
  }

  checkUrlForOpenCart() {
    window.location.href.includes("openCart") ? this.open() : false;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    Array.from(document.getElementsByClassName('cart-item__details')).forEach(item => {
        if (item.querySelector(".cart-item__name").textContent.includes("Gift Card")) {
          Array.from(item.querySelectorAll(".product-option")).forEach((option) => {
                if(option.querySelector("dt") && option.querySelector("dd")){
                    option.querySelector("dt").textContent === "Recipient email:" ? option.querySelector("dt").textContent = "E-mail do presenteado:" : null;
                    option.querySelector("dt").textContent === "Send on:" ? option.querySelector("dt").textContent = "Data de envio:" : null;
                    if( window.innerWidth < 768 && (option.querySelector("dt").textContent === "Message:" || option.querySelector("dt").textContent === "Mensagem:")){
                      option.querySelector("dt").remove();
                      option.querySelector("dd").remove();
                    } else {
                      option.querySelector("dt").textContent === "Message:" ? option.querySelector("dt").textContent = "Mensagem:" : null;
                    }
                }
              
            })
        }
    })
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        let containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        if (!containerToTrapFocusOn) containerToTrapFocusOn = document.getElementById("CartDrawer");
        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  getCart(callback) {
    fetch("/cart.js", {
      credentials: "same-origin",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        callback(cart);
      })
      .catch((error) => console.error("Error:", error));
  }

  updateCart(shouldOpen = true) {
    const sections = this.getSectionsToRender().map((section) => section.id);
    const url = `/?sections=${sections.join(",")}`;
    fetch(url, {
      credentials: "same-origin",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((sections) => {
        const parsedState = {
          id: 0,
          sections,
        };

        this.renderContents(parsedState, shouldOpen);
      })
      .catch((error) => console.error("Error:", error));
  }

  renderContents(parsedState, shouldOpen = true) {
    // console.log(">>>> renderContents");

    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
    this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    // console.log(`Product ID: ${this.productId}`);
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (shouldOpen) {
      setTimeout(() => {
        this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
        this.open();
      });
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() {
    super();
  }

  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);

const ZIPCODE_RANGES = [
  { province: "SP", from: 1000000, to: 19999999 },
  { province: "RJ", from: 20000000, to: 28999999 },
  { province: "ES", from: 29000000, to: 29999999 },
  { province: "MG", from: 30000000, to: 39999999 },
  { province: "BA", from: 40000000, to: 48999999 },
  { province: "SE", from: 49000000, to: 49999999 },
  { province: "PE", from: 50000000, to: 56999999 },
  { province: "AL", from: 57000000, to: 57999999 },
  { province: "PB", from: 58000000, to: 58999999 },
  { province: "RN", from: 59000000, to: 59999999 },
  { province: "CE", from: 60000000, to: 63999999 },
  { province: "PI", from: 64000000, to: 64999999 },
  { province: "MA", from: 65000000, to: 65999999 },
  { province: "PA", from: 66000000, to: 68899999 },
  { province: "AP", from: 68900000, to: 68999999 },
  { province: "AM", from: 69000000, to: 69299999 },
  { province: "RR", from: 69300000, to: 69399999 },
  { province: "AM", from: 69400000, to: 69899999 },
  { province: "AC", from: 69900000, to: 69999999 },
  { province: "DF", from: 70000000, to: 72799999 },
  { province: "GO", from: 72800000, to: 72999999 },
  { province: "DF", from: 73000000, to: 73699999 },
  { province: "GO", from: 73700000, to: 76799999 },
  { province: "RO", from: 76800000, to: 76999999 },
  { province: "TO", from: 77000000, to: 77999999 },
  { province: "MT", from: 78000000, to: 78899999 },
  { province: "MS", from: 79000000, to: 79999999 },
  { province: "PR", from: 80000000, to: 87999999 },
  { province: "SC", from: 88000000, to: 89999999 },
  { province: "RS", from: 90000000, to: 99999999 },
];

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.header = this.querySelector(".shipping-calculator__header");
    this.header.addEventListener("click", this.toggle.bind(this));

    this.zipcodeInput = this.querySelector("#shipping-calculator-zipcode");
    VMasker(this.zipcodeInput).maskPattern("99999-999");

    this.calculateShippingBtn = this.querySelector(".shipping-calculator__calculate-button");
    this.calculateShippingBtn.addEventListener("click", this.prepareShippingRates.bind(this));

    this.ratesWrapper = this.querySelector(".shipping-calculator__result");
    this.showAllRatesBtn = this.querySelector(".rates__show-all-button");
    this.showAllRatesBtn.addEventListener("click", this.showAllRates.bind(this));

    // Check if zip is saved in session storage
    const savedZip = sessionStorage.getItem("insider:cart:shippingZip") || undefined;
    if (savedZip) {
      sessionStorage.setItem("insider:checkout:shippingZip", savedZip);

      this.zipcodeInput.value = savedZip;
      this.prepareShippingRates({ preventDefault: () => {} });
      this.toggle();
    }
    // Preorder flag
    this.hasPreorderItems = false;
  }

  toggle() {
    this.classList.toggle("shipping-calculator--open");
  }

  prepareShippingRates(e) {
    e.preventDefault();

    const country = "Brazil";
    const zip = this.zipcodeInput.value;
    // Save zip in session storage
    sessionStorage.setItem("insider:cart:shippingZip", zip);
    sessionStorage.setItem("insider:checkout:shippingZip", zip);

    const province = this.provinceByZip(zip);
    const query = `shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`;
    const url = `/cart/prepare_shipping_rates.json?${query}`;

    fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        this.calculateShipping(query);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  calculateShipping(query) {
    const url = `/cart/async_shipping_rates.json?${query}`;

    fetch(url, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          this.clearRates();
          this.checkPreorderInCart()
            .then((hasPreorder) => {
              this.hasPreorderItems = hasPreorder;
              this.querySelector('.shipping-calculator__result__rates').innerHTML = this.getRatesHTML(data.shipping_rates);
              this.ratesWrapper.style.display = 'block';
            })
            .catch((error) => {
              console.error('Error checking preorder in cart:', error);
              this.hasPreorderItems = false;
              this.querySelector('.shipping-calculator__result__rates').innerHTML = this.getRatesHTML(data.shipping_rates);
              this.ratesWrapper.style.display = 'block';
            });
        } else {
          setTimeout(() => {
            this.calculateShipping(query);
          }, 500);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async checkPreorderInCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();

      const isPreorderItem = (item) => Boolean(
        item?.selling_plan_allocation ||
        item?.selling_plan 
      );

      return Array.isArray(cart.items) && cart.items.some(isPreorderItem);
    } catch (e) {
      console.error('checkPreorderInCart error:', e);
      return false;
    }
  }

  clearRates() {
    this.ratesWrapper.classList.remove("show-all-rates");
    this.showAllRatesBtn.classList.remove("hidden");
    this.querySelector(".shipping-calculator__result__rates").innerHTML = "";
  }

  getRatesHTML(rates) {
    return rates
      .map((rate) => {
        let deliveryDate = null;
        let deliveryDay = null;
        let deliveryMonth = null;
        if (rate.delivery_range && rate.delivery_range.length > 0) {
          deliveryDate = rate.delivery_range.length > 1 ? rate.delivery_range[1] : rate.delivery_range[0];
          deliveryDay = deliveryDate.split("-")[2];
          deliveryMonth = deliveryDate.split("-")[1];
        }

        const priceCents = parseFloat(rate.price) * 100;

        return `
          <div class="shipping-calculator__result-item">
            <p class="rate-name">${rate.name}${
          deliveryDate && !this.hasPreorderItems ? ` | Entrega até dia ${deliveryDay}/${deliveryMonth}` : ""
        }</p>
            <p class="rate-price">${priceCents > 0 ? this.formatMoney(priceCents) : "GRÁTIS"}</p>
          </div>
        `;
      })
      .join("");
  }

  formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace(".", ",");
    return `R$ ${value.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  }

  provinceByZip(zip) {
    const zipNumber = parseInt(zip.replace("-", ""));
    const zipRange = ZIPCODE_RANGES.find((range) => range.from <= zipNumber && range.to >= zipNumber);
    return zipRange ? zipRange.province : "SP";
  }

  showAllRates(e) {
    e.preventDefault();
    this.ratesWrapper.classList.add("show-all-rates");
    this.showAllRatesBtn.classList.add("hidden");
  }
}
customElements.define("shipping-calculator", ShippingCalculator);

class PromotionCoupon extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector(".promotion-coupon__header");
    this.header.addEventListener("click", this.toggle.bind(this));

    this.cartDrawer = document.querySelector("cart-drawer");

    this.inputPromotionCoupon = this.querySelector("#promotion-coupon-code");

    this.applyCouponBtn = this.querySelector(".promotion-coupon__calculate-button");
    this.applyCouponBtn.addEventListener("click", this.addPromotionCoupon.bind(this));

    this.clearButton = this.querySelector(".remove-promotion-coupon");
    this.clearButton.addEventListener("click", this.clearDiscount.bind(this));

    this.customerId = window?.__st?.cid ?? null;
  }

  connectedCallback() {
    this.getCart((cart) => {
      this.cart = cart;
      const appliedDiscountsToCart = (() => {
        const discounts = new Set([
          ...cart.cart_level_discount_applications.map((discount) => discount.title),
          ...this.getDiscountAppliedInProducts(cart),
        ]);
        return Array.from(discounts);
      })();
      const hasPromotionCouponInCache = this.setInformationPromotionCoupon();
      const hasSamePromotionCouponInCart = cart.cart_level_discount_applications.some(
        (discount) => discount.title === this.dataPromotionCoupon?.code
      );
      const hasSamePromotionCouponInProducts = cart.items.some((item) =>
        item.discounts.some((discount) => discount.title === this.dataPromotionCoupon?.code)
      );
      const hasCouponFreeShipping = this.dataPromotionCoupon?.data?.discount?.target_type === "shipping_line";

      if (appliedDiscountsToCart.length && !appliedDiscountsToCart.includes(this.dataPromotionCoupon?.code)) {
        this.addPromotionCoupon(undefined, appliedDiscountsToCart[0]);
      } else if (hasPromotionCouponInCache && (hasSamePromotionCouponInCart || hasSamePromotionCouponInProducts)) {
        this.promotionCouponActive(cart);
      } else if (hasPromotionCouponInCache && hasCouponFreeShipping) {
        this.addPromotionCoupon(undefined, this.dataPromotionCoupon.code);
      } else if (hasPromotionCouponInCache) {
        this.addPromotionCoupon(undefined, this.dataPromotionCoupon.code);
      } else {
        this.clearDiscount();
      }
    });
  }

  setInformationPromotionCoupon() {
    const promotionCoupon = JSON.parse(sessionStorage.getItem("insider:cart:promotionCoupon")) || undefined;
    if (!promotionCoupon || !promotionCoupon.code) return false;
    this.dataPromotionCoupon = promotionCoupon;
    this.inputPromotionCoupon.value = this.dataPromotionCoupon.code;

    return true;
  }

  getDiscountAppliedInProducts(cart) {
    const discountTitles = new Set();
    cart.items.forEach((item) => {
      item.discounts.forEach((discount) => {
        if (
          discount.title &&
          !discount.title.includes("Desconto kit") &&
          !discount.title.includes("Kit discount") &&
          !discount.title.includes("%") &&
          !discount.title.includes("R$")
        ) {
          discountTitles.add(discount.title.trim());
        }
      });
    });
    return Array.from(discountTitles);
  }

  formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace(".", ",");
    return `R$ ${value.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  }

  toggle() {
    this.classList.toggle("promotion-coupon--open");
  }

  promotionCouponActive(oldCart) {
    this.classList.add("promotion-coupon--open");
    this.classList.add("coupon-active");

    this.querySelector(".text-promotion-code").innerHTML = this.dataPromotionCoupon.code;
    const discountData = this.dataPromotionCoupon.data.discount;

    if (discountData) {
      if (discountData.target_type === "shipping_line") {
        this.classList.add("coupon-active-free-shipping");
      }

      if (discountData.target_type !== "shipping_line" && discountData.value === "0.0") {
        this.classList.add("coupon-active-zero-coupon");
      }

      let discount = 0;
      if (discountData.allocation_method == "each") {
        let totalDiscount = 0;

        const productsAtInCart = Array.from(this.cartDrawer.querySelectorAll(".cart-items .cart-item")).filter(
          (productEl) => {
            const colectionsIds = productEl
              .getAttribute("data-colectionsids")
              .split(",")
              .filter((id) => id);
            const productid = productEl.getAttribute("data-productid");
            const variantid = productEl.getAttribute("data-variantid");

            const hasInColectionId = colectionsIds.some((item) =>
              discountData.entitled_collection_ids.includes(Number(item))
            );
            const hasInProduct = discountData.entitled_product_ids.includes(Number(productid));
            const hasInVariant = discountData.entitled_variant_ids.includes(Number(variantid));

            return hasInColectionId || hasInProduct || hasInVariant;
          }
        );

        if (productsAtInCart.length > 0) {
          productsAtInCart.forEach((product) => {
            // const productkey = product.getAttribute("data-key");
            const productid = product.getAttribute("data-productid");
            const variantid = product.getAttribute("data-variantid");

            const priceProduct = oldCart.items.find((item) => {
              // if (item.properties._key && productkey) return item.properties._key == productkey;
              return item.product_id == productid || item.variant_id == variantid;
            });

            if (priceProduct) {
              let priceDiscount = 0;
              if (discountData.value_type == "percentage") {
                priceDiscount = (priceProduct.final_price / 100) * Math.abs(discountData.value);
              } else {
                priceDiscount = Math.abs(discountData.value) * 100;
              }

              totalDiscount += priceDiscount * priceProduct.quantity;
              const priceWrapper = product.querySelector(`.cart-item__price-wrapper`);
              if (priceWrapper) priceWrapper.querySelector(".price--end").classList.add("price-without-discount");

              this.updatePriceItemCart(priceProduct, priceDiscount, priceWrapper, this.dataPromotionCoupon.code);
            }
          });
        }
        discount = totalDiscount;
      } else {
        if (discountData.value_type == "percentage") {
          discount = (oldCart.original_total_price / 100) * Math.abs(discountData.value);
          oldCart.items.forEach((product) => {
            const discountItem = (product.final_price / 100) * Math.abs(discountData.value);
            const priceWrapper = this.cartDrawer.querySelector(
              (() => {
                // if (product.properties._key) return `[data-key="${product.properties._key}"] .cart-item__price-wrapper`;
                return `[data-variantid="${product.variant_id}"] .cart-item__price-wrapper`;
              })()
            );

            this.updatePriceItemCart(product, discountItem, priceWrapper, this.dataPromotionCoupon.code);
          });
        } else {
          discount = Math.abs(discountData.value) * 100;
        }
      }

      this.querySelector(".text-price-with-discount").innerHTML = `- ${this.formatMoney(discount)}`;

      const priceWithDiscount = oldCart.original_total_price - discount;

      if (
        !oldCart.cart_level_discount_applications.some((discount) => discount.title === this.dataPromotionCoupon.code)
      )
        document.querySelector(".subtotal .subtotal__header--value").innerHTML = this.formatMoney(priceWithDiscount);
    } else {
      if (this.dataPromotionCoupon.discount_config) {
        this.classList.add("coupon-active-zero-coupon");
      }
    }
  }

  updatePriceItemCart(product, discountItem, element, discountCode) {
    if (!element) return;
    element.querySelector(".price--end").classList.add("price-without-discount");
    const toHide = element.querySelector(".price--end:not(.price-without-discount)");
    if (toHide) {
      toHide.style.display = "none";
      toHide.classList.add("hidded-price");
    }
    let spanDiscount = element.querySelector(".price-added-by-app");
    if (!spanDiscount) {
      spanDiscount = document.createElement("span");
      spanDiscount.classList.add("price-with-discount");
      spanDiscount.classList.add("price-added-by-app");
      element.appendChild(spanDiscount); // Adicionar o span ao elemento
    }
    const hasDiscountApplied = product.discounts.some(
      (discount) => discount.title === discountCode && !(discount.amount === 0 && discount.title.includes("ESPECIAL"))
    );

    const newPrice = (product.line_price - (hasDiscountApplied ? 0 : discountItem)) * product.quantity;
    const currentPrice = parseFloat(spanDiscount.innerHTML.replace("R$ ", "").replace(",", "."));
    if (isNaN(currentPrice) || newPrice < currentPrice * 100) {
      spanDiscount.innerHTML = `${this.formatMoney(newPrice)}`;
    }
  }

  clearDiscount() {
    this.getCart((cart) => {
      this.classList.remove("coupon-active");
      this.classList.remove("coupon-active-free-shipping");
      this.classList.remove("coupon-active-zero-coupon");
      this.querySelector(".text-promotion-code").innerHTML = "";
      this.querySelector(".text-price-with-discount").innerHTML = "";
      this.cartDrawer.querySelectorAll(".hidded-price").forEach((element) => {
        element.style.display = "block";
        element.classList.remove("hidded-price");
      });
      Array.from(this.cartDrawer.querySelectorAll(".cart-item")).map((product) => {
        const priceWrapper = product.querySelector(`.cart-item__price-wrapper`);
        const element = priceWrapper.querySelector(".price--end");
        const toRemove = product.querySelector(".price-added-by-app");
        if (toRemove) toRemove.remove();
        element.classList.remove("price-without-discount");
        element.classList.remove("price-added-by-app");
      });
      if (this.dataPromotionCoupon && this.dataPromotionCoupon.oldCart) {
        this.dataPromotionCoupon.oldCart.items.forEach((product) => {
          const priceWrapper = this.cartDrawer.querySelector(
            (() => {
              // if (product.properties._key) return `[data-key="${product.properties._key}"] .cart-item__price-wrapper`;
              return `[data-variantid="${product.variant_id}"] .cart-item__price-wrapper`;
            })()
          );
          this.updatePriceItemCart(product, 0, priceWrapper, "");
        });
      }

      fetch(`/discount/REMOVE_DISCOUNT_CODES?v=${Date.now()}`, {}).finally(() => {
        document.querySelector(".subtotal .subtotal__header--value").innerHTML = this.formatMoney(
          cart.original_total_price
        );
        const sessionData = JSON.parse(sessionStorage.getItem("insider:cart:promotionCoupon"));
        delete sessionData.data;
        delete sessionData.code;
        delete sessionData.oldCart;
        this.dataPromotionCoupon = sessionData;

        if (sessionData) {
          sessionStorage.setItem(
            "insider:cart:promotionCoupon",
            JSON.stringify({ ...this.dataPromotionCoupon, oldCart: cart })
          );
        }
      });
    });
  }

  getCart = async (callback) => {
    const response = await fetch("/cart.js");
    const data = await response.json();
    callback(data);
  };

  addPromotionCoupon(e, forcePromotionCoupon) {
    e?.preventDefault();

    const promotionCoupon = forcePromotionCoupon ?? this.inputPromotionCoupon.value.toUpperCase();
    if (!promotionCoupon) {
      this.inputPromotionCoupon.focus();
      return;
    }

    if (!forcePromotionCoupon) {
      window.dataLayer.push({
        event: `click_apply_coupon_in_cart`,
        timestamp: new Date().toISOString(),
        promotionCoupon: promotionCoupon,
      });
    } else {
      window.dataLayer.push({
        event: `auto_apply_coupon_in_cart`,
        timestamp: new Date().toISOString(),
        promotionCoupon: promotionCoupon,
      });
    }

    this.applyCouponBtn.classList.add("loading");

    const discountsCuponsArray = Object.keys(this.dataPromotionCoupon.discounts_cupons.discount_codes);
    const discountsCuponsArrayFiltered = discountsCuponsArray.filter((discount) =>
      promotionCoupon.includes(discount.toLocaleUpperCase())
    );

    if (discountsCuponsArrayFiltered.length === 0) {
      this.getDataCouponDiscount(promotionCoupon);
    } else {
      const sessionData = JSON.parse(sessionStorage.getItem("insider:cart:promotionCoupon"));
      this.dataPromotionCoupon = {
        discount_config: sessionData.discounts_cupons.discount_codes[promotionCoupon],
        discounts_cupons: sessionData.discounts_cupons,
        data: {},
        code: promotionCoupon,
        oldCart: null,
      };

      sessionStorage.setItem("insider:cart:promotionCoupon", JSON.stringify(this.dataPromotionCoupon));
      this.getCart(async (cart) => {
        this.insertCouponInCheckout(promotionCoupon);
        this.promotionCouponActive(cart);
      });
    }

    this.applyCouponBtn.classList.remove("loading");
  }

  insertCouponInCheckout(promotionCoupon) {
    const discountApplyUrl = `/discount/${promotionCoupon}?v=${Date.now()}`;
    fetch(discountApplyUrl, {}).then(function (response) {
      return response.text();
    });
  }

  getDataCouponDiscount(promotionCoupon) {
    this.getCart(async (cart) => {
      const body = {
        code: promotionCoupon.trim(),
        cart: cart,
        customer: (() => {
          if (this.customerId) {
            return {
              id: this.customerId,
            };
          }
          return null;
        })(),
      };

      try {
        await fetch(
          "https://us-central1-insider-integrations.cloudfunctions.net/validate-discount-code-prod/v1/discount-code",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          }
        ).then((response) => {
          response.json().then((data) => {
            if (!data.valid) {
              if (data?.discount) {
                this.setMessages("Este desconto atingiu o limite de uso.");
              } else {
                this.setMessages("Insira um código de desconto ou cartão-presente válido.");
              }
            } else {
              const sessionData = JSON.parse(sessionStorage.getItem("insider:cart:promotionCoupon"));

              this.dataPromotionCoupon = {
                discounts_cupons: sessionData.discounts_cupons,
                data,
                code: promotionCoupon,
                oldCart: cart,
              };
              sessionStorage.setItem(
                "insider:cart:promotionCoupon",
                JSON.stringify({ ...this.dataPromotionCoupon, oldCart: cart })
              );

              this.promotionCouponActive(cart);
              this.insertCouponInCheckout(promotionCoupon);
            }
          });
        });
      } catch (error) {
        console.error("Error:", error);
      }
    });

    return true;
  }

  setMessages(message) {
    this.querySelector(".promotion-coupon__result-message").classList.add("active");
    this.querySelector(".promotion-coupon__message").innerHTML = message;

    setTimeout(() => {
      this.querySelector(".promotion-coupon__result-message").classList.remove("active");
    }, 10000);
  }
}

customElements.define("promotion-coupon", PromotionCoupon);

// Cart Drawer Tiered Promo messages (moved from Liquid inline script)
(function initCartProgressMessages(){
  if (window.__insider_cartProgressInit) return; // prevent double init on re-renders
  window.__insider_cartProgressInit = true;

  function parseDiscountTiers(rawTiers) {
    var list = rawTiers || [];
    if (!Array.isArray(list)) list = [list];
    return list
      .map(function (t) {
        var required = Number(t.quantityRequiredForDiscount ?? t.minimumToBuy ?? t.required);
        var discount = t.percentualDiscount != null ? Number(t.percentualDiscount) : null;
        if (Number.isNaN(required) || required <= 0) return null;
        if (discount === null || Number.isNaN(discount) || discount <= 0) return null;
        return { required: required, discount: discount, type: 'discount' };
      })
      .filter(Boolean)
      .sort(function (a, b) { return a.required - b.required; });
  }

  function parseGiftTiers(rawTiers) {
    var list = rawTiers || [];
    if (!Array.isArray(list)) list = [list];
    return list
      .map(function (t) {
        // Support multiple schemas for Buy X Get Y style promos
        var required = (
          t.quantityRequiredToBeGifted ??
          t.quantityRequired ??
          t.buyQuantity ??
          t.minimumToBuy ??
          t.x ??
          t.required
        );
        var gifted = (
          t.quantityToBeGifted ??
          t.getQuantity ??
          t.y ??
          t.quantityFree ??
          t.gifted ??
          1
        );
        var reqNum = Number(required);
        var giftNum = Number(gifted);
        if (Number.isNaN(reqNum) || reqNum <= 0) return null;
        var safeGifted = !Number.isNaN(giftNum) && giftNum > 0 ? giftNum : 1;
        return { required: reqNum, gifted: safeGifted, type: 'gift' };
      })
      .filter(Boolean)
      .sort(function (a, b) { return a.required - b.required; });
  }

  function normalizeTiers(rawTiers) {
    var discountTiers = parseDiscountTiers(rawTiers);
    if (discountTiers.length) return discountTiers;
    return parseGiftTiers(rawTiers);
  }

  function isDiscountMode(tiers) {
    return Array.isArray(tiers) && tiers.some(function (t) {
      return t.type === 'discount' && (t.discount || 0) > 0;
    });
  }

  function computeDiscountMessage(currentQuantity, tiers) {
    if (!tiers || !tiers.length) return '';
    var nextEligibleTier = null;
    var highestUnlockedTier = null;
    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      if (currentQuantity < tier.required && !nextEligibleTier) nextEligibleTier = tier;
      if (currentQuantity >= tier.required) highestUnlockedTier = tier;
    }
    var parts = [];
    if (highestUnlockedTier && (highestUnlockedTier.discount || 0) > 0) {
      var currPct = Math.round(Number(highestUnlockedTier.discount || 0));
      parts.push('Você já tem ' + currPct + '% OFF');
    }
    
    if (nextEligibleTier) {
      var missing = nextEligibleTier.required - currentQuantity;
      var nextPct = Math.round(Number(nextEligibleTier.discount || 0));
      parts.push('Desbloqueie ' + nextPct + '% OFF com mais ' + missing + ' unidades* no carrinho (*ver itens disponíveis)');
    }
    if (!parts.length && highestUnlockedTier && (highestUnlockedTier.discount || 0) > 0) {
      var pct2 = Math.round(Number(highestUnlockedTier.discount || 0));
      parts.push('Desconto máximo desbloqueado. Aproveite seus ' + pct2 + '% OFF com mais itens tecnológicos');
    }
    return parts.join('. ');
  }

  function computeGiftMessage(currentQuantity, tiers) {
    if (!tiers || !tiers.length) return '';
    var nextEligibleTier = null;
    var highestUnlockedTier = null;
    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      if (currentQuantity < tier.required && !nextEligibleTier) nextEligibleTier = tier;
      if (currentQuantity >= tier.required) highestUnlockedTier = tier;
    }
    var parts = [];
    if (highestUnlockedTier && (highestUnlockedTier.gifted || 0) > 0) {
      var giftedLabelCurr = highestUnlockedTier.gifted === 1 ? '1 peça' : String(highestUnlockedTier.gifted) + ' peças';
      parts.push('Promoção desbloqueada: leve ' + giftedLabelCurr + ' grátis');
    }
    if (nextEligibleTier) {
      var missing = nextEligibleTier.required - currentQuantity;
      var giftedLabelNext = nextEligibleTier.gifted === 1 ? '1 peça' : String(nextEligibleTier.gifted) + ' peças';
      parts.push('Com mais ' + missing + ' peça' + (missing !== 1 ? 's' : '') + ', você desbloqueia ' + giftedLabelNext + ' grátis no carrinho');
    }
    if (!parts.length && highestUnlockedTier && (highestUnlockedTier.gifted || 0) > 0) {
      // var giftedLabelMax = highestUnlockedTier.gifted === 1 ? '1 peça' : String(highestUnlockedTier.gifted) + ' peças';
      parts.push('Máximo de peças gratuitas selecionadas');
    }
    return parts.join('. ');
  }

  function computePromoMessage(qty, tiers) {
    if (!tiers || !tiers.length) return '';
    return isDiscountMode(tiers) ? computeDiscountMessage(qty, tiers) : computeGiftMessage(qty, tiers);
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function refreshMessages() {
    var groups = Array.prototype.slice.call(document.querySelectorAll('.cart-promo-group'));
    if (!groups.length) return;

    groups.forEach(function (el) {
      var tiersAttr = el.getAttribute('data-tiers');
      var promoProductList = el.getAttribute('data-promo-product-list');
      var msg = [];

      if (tiersAttr) {
        var totalQty = Array.from(el.querySelectorAll('.quantity__input'))
          .map(function(qtyInput) { return Number(qtyInput.value || qtyInput.getAttribute('value') || 0); })
          .reduce(function(a, b) { return a + b; }, 0);

        var raw;
        try { raw = JSON.parse(tiersAttr); } catch (e) { raw = []; }
        var tiers = normalizeTiers(raw);
        msg.push(computePromoMessage(totalQty, tiers));
      }

      msg.push(`<a href="/${promoProductList}">Ver Itens</a>`)
      msg = msg.join('. ');

      var target = el.querySelector('.promo-group__progress-message');
      if (target && target.innerHTML !== msg) {
        target.innerHTML = msg || '';
      }
    });
  }

  // initial + event wiring
  document.addEventListener('DOMContentLoaded', refreshMessages, { once: true });
  refreshMessages();
  ['cart:updated', 'cart:change', 'cart:refresh', 'cart:requestComplete', 'quantity:change'].forEach(function (evt) {
    document.addEventListener(evt, refreshMessages);
  });

  var debouncedRefresh = debounce(refreshMessages, 120);

  // Delegate clicks on plus/minus buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quantity__button');
    if (btn) {
      setTimeout(debouncedRefresh, 120);
    }
  });

  // Listen to direct edits on number inputs (if enabled)
  document.addEventListener('input', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('quantity__input')) {
      debouncedRefresh();
    }
  });

  // Observe quantity value attribute/text changes within the cart drawer
  var cartRoot = document.querySelector('#CartDrawer');
  if (cartRoot && 'MutationObserver' in window) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes' && m.target.classList && m.target.classList.contains('quantity__input') && m.attributeName === 'value') {
          debouncedRefresh();
          break;
        }
        if (m.type === 'childList') {
          debouncedRefresh();
          break;
        }
      }
    });
    mo.observe(cartRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['value'] });
  }
})();

(function initOrderLevelCouponVisualizer() {
  if (window.__insider_orderCouponInit) return;
  window.__insider_orderCouponInit = true;

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace(".", ",");
    return "R$ " + value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (res) { return res.json(); })
      .catch(function () { return null; });
  }

  function resetLineItemPrices() {
    var priceEls = document.querySelectorAll(".cart-items .cart-item__price-wrapper .price--end");
    Array.prototype.forEach.call(priceEls, function (priceEl) {
      var original = priceEl.getAttribute("data-order-coupon-original-price");
      if (original) {
        priceEl.innerHTML = original;
      }
      priceEl.classList.remove("price-without-discount", "order-coupon-price-added");
      var wrapper = priceEl.parentElement;
      if (wrapper) {
        var extra = wrapper.querySelector(".order-coupon-price");
        if (extra) extra.remove();
      }
    });
  }

  function clearFixedDiscountRow() {
    var row = document.getElementById("order-level-fixed-discount-row");
    if (row && row.parentNode) {
      row.parentNode.removeChild(row);
    }
  }

  function findCartItem(cart, cartItemEl, usedIndexes) {
    if (!cart || !cart.items) return null;
    var productId = cartItemEl.getAttribute("data-productid");
    var variantId = cartItemEl.getAttribute("data-variantid");
    var key = cartItemEl.getAttribute("data-key");

    // Quando temos mecânicas de compre e ganhe, podemos ter múltiplos line items
    // com o mesmo product_id/variant_id. Para não sempre pegar o primeiro,
    // percorremos todos os itens que "batem" e escolhemos o primeiro ainda não usado.
    var candidates = [];
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var match = false;

      if (key && item.properties && item.properties._key && String(item.properties._key) === String(key)) {
        match = true;
      } else if (variantId && item.variant_id && String(item.variant_id) === String(variantId)) {
        match = true;
      } else if (productId && item.product_id && String(item.product_id) === String(productId)) {
        match = true;
      }

      if (match) {
        candidates.push({ index: i, item: item });
      }
    }

    if (!candidates.length) return null;

    if (usedIndexes) {
      for (var j = 0; j < candidates.length; j++) {
        var c = candidates[j];
        if (!usedIndexes[c.index]) {
          usedIndexes[c.index] = true;
          return c.item;
        }
      }
      // Se todos os candidates já foram usados, cai no primeiro por segurança.
      usedIndexes[candidates[0].index] = true;
      return candidates[0].item;
    }

    // Comportamento "antigo" quando não usamos controle de índice
    return candidates[0].item;
  }

  function applyPercentageCoupon(cart, app) {
    if (!cart || !app) return;

    var rawValue = Number(app.value || app.percentage || 0);
    if (isNaN(rawValue) || !rawValue) return;

    var pct = Math.abs(rawValue);
    if (pct <= 0) return;

    var cartItemEls = document.querySelectorAll(".cart-items .cart-item");
    if (!cartItemEls.length) return;

    var usedCartItemIndexes = {};
    Array.prototype.forEach.call(cartItemEls, function (cartItemEl) {
      var cartItem = findCartItem(cart, cartItemEl, usedCartItemIndexes);
      if (!cartItem) return;

      var baseLine = Number(cartItem.final_line_price || cartItem.line_price || 0);
      if (!baseLine) return;

      var discountedLine = Math.round((baseLine * (100 - pct)) / 100);

      var priceWrapper = cartItemEl.querySelector(".cart-item__price-wrapper");
      if (!priceWrapper) return;

      var priceEnd = priceWrapper.querySelector(".price--end");
      if (!priceEnd) return;

      var hasOldPrice = !!priceWrapper.querySelector(".cart-item__old-price");

      if (!priceEnd.getAttribute("data-order-coupon-original-price")) {
        priceEnd.setAttribute("data-order-coupon-original-price", priceEnd.innerHTML);
      }

      // Se já existe um old price, não criamos um segundo preço com desconto.
      // Apenas sobrescrevemos o valor exibido no priceEnd com o valor já com cupom de pedido.
      if (hasOldPrice) {
        priceEnd.innerHTML = formatMoney(discountedLine);
        return;
      }

      // Caso não tenha old price, mantemos o comportamento anterior:
      // mostramos o preço original "riscado" e adicionamos um span com o preço com desconto.
      priceEnd.classList.add("price-without-discount", "order-coupon-price-added");

      var discountSpan = priceWrapper.querySelector(".order-coupon-price");
      if (!discountSpan) {
        discountSpan = document.createElement("span");
        discountSpan.className = "price-with-discount order-coupon-price";
        priceWrapper.appendChild(discountSpan);
      }

      discountSpan.innerHTML = formatMoney(discountedLine);
    });
  }

  function applyFixedCouponRow(cart, app) {
    clearFixedDiscountRow();
    if (!cart || !app) return;
    if (app.value_type !== "fixed_amount") return;

    var subtotalEl = document.querySelector(".subtotal");
    if (!subtotalEl || !subtotalEl.parentNode) return;

    var discountCents = 0;

    if (typeof app.total_allocated_amount === "number") {
      discountCents = Math.round(Math.abs(app.total_allocated_amount));
    } else if (typeof app.total_allocated_amount === "string") {
      var num = parseFloat(app.total_allocated_amount.replace(",", "."));
      if (!isNaN(num)) {
        discountCents = Math.round(Math.abs(num) * 100);
      }
    }

    if (!discountCents && typeof cart.total_discount === "number") {
      discountCents = Math.round(Math.abs(cart.total_discount));
    }

    if (!discountCents) return;

    var row = document.createElement("div");
    row.id = "order-level-fixed-discount-row";
    row.className = "subtotal__row subtotal__row--order-discount";
    row.style.display = "flex";
    row.style.justifyContent = "space-between";
    row.style.alignItems = "center";
    row.style.padding = "0 16px";
    row.style.fontSize = "12px";
    row.innerHTML =
      '<span class="subtotal__title">Desconto do pedido</span>' +
      '<span class="subtotal__header--value subtotal__header--value--discount" style="font-size: 12px; font-weight: 600;">- ' +
      formatMoney(discountCents) +
      "</span>";

    subtotalEl.parentNode.insertBefore(row, subtotalEl);
  }

  function applyOrderCoupons(cart) {
    resetLineItemPrices();
    clearFixedDiscountRow();

    if (!cart || !Array.isArray(cart.cart_level_discount_applications) || !cart.cart_level_discount_applications.length) {
      return;
    }

    var percentageApp = cart.cart_level_discount_applications.find(function (app) {
      return app.value_type === "percentage";
    });

    var fixedApp = cart.cart_level_discount_applications.find(function (app) {
      return app.value_type === "fixed_amount";
    });

    if (percentageApp) {
      applyPercentageCoupon(cart, percentageApp);
    }

    if (fixedApp) {
      applyFixedCouponRow(cart, fixedApp);
    }
  }

  function handleCartUpdate(evt) {
    var cart = (evt && (evt.cart || (evt.detail && evt.detail.cart))) || null;

    if (cart) {
      applyOrderCoupons(cart);
      return;
    }

    getCart().then(function (freshCart) {
      applyOrderCoupons(freshCart);
    });
  }

  // Garante que, após a hidratação/renderização do CartDrawer via Sections,
  // o cupom de pedido seja reaplicado aos line items.
  if (typeof CartDrawer === "function" && !CartDrawer.prototype.__orderCouponPatched) {
    CartDrawer.prototype.__orderCouponPatched = true;
    var __originalRenderContents = CartDrawer.prototype.renderContents;
    CartDrawer.prototype.renderContents = function (parsedState, shouldOpen) {
      // chama o comportamento original de renderização
      __originalRenderContents.call(this, parsedState, shouldOpen);
      // depois que o HTML do carrinho foi reidratado/renderizado,
      // buscamos o cart e reaplicamos o cupom de pedido nos line items.
      getCart().then(function (cart) {
        applyOrderCoupons(cart);
      });
    };
  }

  if (typeof subscribe === "function" && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      getCart().then(function (cart) {
        applyOrderCoupons(cart);
      });
    });
  } else {
    getCart().then(function (cart) {
      applyOrderCoupons(cart);
    });
  }
})();
